<template>
  <div class="question">
    <div :class="[noFlexBox ? '' : 'flex-box', 'vertically-at-top', 'wrap', showTextField ? 'mutiple-line' : '']">
      <div class="calc-left">
        <div class="question-text">
          {{question}}
        </div>
      </div>
      <div class="calc-right">
        <select :class="['select', error ? 'error-input' : '']" @change="answerChanged" v-model="currentAnswer">
          <option value="-" disabled="" >—</option>
          <option v-for="option in answerOptions" :value="option.enum" :key="option.text">{{option.text}}</option>
        </select>
        <div class="gap-2x" v-if="showTextField" />
        <input
          :class="['text-input', error ? 'error-input' : '']"
          v-model="textInput"
          :placeholder="textPlaceholder"
          v-if="showTextField"
          @change="onTextChange"
        />
        <div class="gap-1x" v-if="error" />
        <div class="error-message" v-if="error">{{error}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'SelectQuestion',
  props: [
    "question", "answerOptions", "answer", "onAnswerChange", "questionId",
    "onTextChange", "additionalTextFieldValue", "additionalTextFieldIndexes",
    "textPlaceholders", "noFlexBox", "error"
  ],
  data: function() {
    return {
      currentAnswer: this.answer || '-',
      textInput: this.aduPrimarySourceExplain
    }
  },
  methods: {
    answerChanged: function(event) {
      this.onAnswerChange(this.questionId, event.target.value);
    },
    answerIndex: function() {
      return _.map(this.answerOptions, 'enum').indexOf(this.currentAnswer);
    }
  },
  computed: {
    showTextField: function() {
      var index = this.additionalTextFieldIndexes || [];
      return index.indexOf(this.answerIndex()) >= 0;
    },
    textPlaceholder: function() {
      return this.textPlaceholders[this.answerIndex()];
    },
  }
}
</script>

<style>
  .vertically-at-top.mutiple-line {
    align-items: baseline;
  }
</style>
